module.exports = __webpack_public_path__ + "static/media/worksessions_photos_052123.eef0b531.png";